(function () {
  class ReelSpinnerVisual extends SlotsEngine.types.ReelSpinnerVisual {
    constructor(
      reelId,
      name,
      maxAppertureHeight,
      slotMach,
      minSpacing,
      reservedSpace,
      numPreapp,
      numPostapp,
      startingAppertureHeight,
      megawaysSymbolSpacing
    ) {
      super(
        reelId,
        name,
        maxAppertureHeight,
        slotMach,
        minSpacing,
        reservedSpace,
        numPreapp,
        numPostapp,
        false, //not dynamic spinner,
        false, //not nudge reel
        megawaysSymbolSpacing
      );

      this._reelId = parseInt(reelId.replace("reel", ""));
      this.setAppertureHeight(startingAppertureHeight);

      this.initialiseSymbolSizes(resourceManager.configuration.symbols);

      this._overlays = [];
      this._possibleCoinValues = [10, 20, 30, 40, 50, 100];
      this._coinDataOnReel = [];
      this.coinDisplayMode = true;
      this.multiplierStakeForCurrentSpin = 100;
      this.spawnedAnticipationSymbol = false;
      this.sliding = false;
      this.slidingCollectPool = [];
      this.slidingPoolLength = 0;
      this.startingAppertureHeight = startingAppertureHeight;

      this._coinSymbolIds = [
        100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121,
        122, 123, 124, 125, 126, 127, 128, 129,
      ];

      this._fakeCoinIds = [13, 33, 53, 73, 93];

      this._fishSymbolMapOffsetToID = {
        0: 100,
        1: 106,
        2: 112,
        3: 118,
        4: 124,
      };

      this._weightedRandomFishRanges = [
        { min: 0.5, max: 3, weight: 0.4, id: 0 },
        { min: 3, max: 4, weight: 0.25, id: 1 },
        { min: 5, max: 6, weight: 0.15, id: 2 },
        { min: 8, max: 10, weight: 0.1, id: 3 },
        { min: 15, max: 20, weight: 0.06, id: 4 },
        { min: 25, max: 50, weight: 0.04, id: 5 },
      ];

      // 7 means reel is 7 symbols high
      this._maxHeightPerSymbolSize = {
        3: 35,
        4: 30,
        5: 27.5,
        6: 27.5,
        7: 25,
      };

      this._textPositionsPerSize = {
        3: 170,
        4: 122.5,
        5: 100,
        6: 80,
        7: 68.5,
      };
    }

    getFishIdFromFakeCoinId() {
      // get random weighted fish type
      const totalWeight = this._weightedRandomFishRanges.reduce((acc, curr) => acc + curr.weight, 0);
      let random = Math.random() * totalWeight;

      let selectedRange;

      for (const range of this._weightedRandomFishRanges) {
        if (random < range.weight) {
          selectedRange = range;
          break;
        }
        random -= range.weight;
      }

      if (!selectedRange) {
        selectedRange = this._weightedRandomFishRanges[0];
      }

      const randomValueWithinRange = Math.floor(
        Math.random() * (selectedRange.max - selectedRange.min + 1) + selectedRange.min
      );
      const id = selectedRange.id;

      const currentSymSize = this.appertureHeight - 3;

      return { symId: this._fishSymbolMapOffsetToID[currentSymSize] + id, multiplier: randomValueWithinRange };
    }

    resetAllSymbolData() {
      let symbolData = this._reelSpinnerData.getSymbolData();
      symbolData.forEach((symData) => {
        symData.symId = 0;
      });
    }

    updateSymbols() {
      let symbolData = this._reelSpinnerData.getSymbolData();

      symbolData.forEach((symData) => {
        // if this is a fake coin (doesn't land, just spin through)
        if (this._fakeCoinIds.includes(symData.symId)) {
          const getFishIdFromFakeCoinId = this.getFishIdFromFakeCoinId();
          symData.symId = getFishIdFromFakeCoinId.symId;
          symData.overlayData.fakeMultiplierValue = getFishIdFromFakeCoinId.multiplier;
        }
      });

      let overlays = [];

      for (let i = 0; i < symbolData.length; ++i) {
        const symbolID = symbolData[i].symId;
        overlays.push(symbolData[i].overlayData);

        if (symbolID < 20 && this.appertureHeight > 3) {
          const symbolIDOffset = this.appertureHeight - 3;
          symbolData[i].symId += symbolIDOffset * 20;
        }
      }

      super.updateSymbols();

      for (
        let i = 0;
        (i < symbolData.length && this._reelId === 0) || (i < symbolData.length && this._reelId === 4);
        ++i
      ) {
        const symbolID = symbolData[i].symId;
        const symbol = resourceManager.get(`slotContainer:reelContainer:reel${this._reelId}:symbol${i}:symbol`);

        if (
          (symbolID === 54 &&
            gameController.checkIfCollectIsSliding(this._reelId) &&
            gameController.inFreeSpins &&
            !gameController.inBuyABonusFirstSpin) ||
          (symbolID === 54 && this.sliding && gameController.inFreeSpins && !gameController.inBuyABonusFirstSpin)
        ) {
          this.sliding = true;
          symbol.alpha = 0;
        } else {
          symbol.alpha = 1;
        }
      }
    }

    setAppertureHeight(numInWindow) {
      super.setAppertureHeight(numInWindow);
      this.appertureHeight = numInWindow;
    }

    dimSymbol(row, showDim, duration) {
      const self = this;
      const overlay = self._overlays[row].overlayText;

      if (showDim) {
        overlay.alpha = 0.8;
      } else {
        overlay.alpha = 1;
      }

      let targetTint = showDim ? this._dimTint : 0xffffff;

      const symbol = self._symbolGfxObjects[row].symbol;
      gsap.killTweensOf(symbol);

      if (duration) {
        gsap.to(symbol, {
          duration,
          pixi: { tint: targetTint },
        });
      } else {
        symbol.tint = targetTint;
      }
    }

    initialiseSymbolSizes(symbolData) {
      this._symbolSizes = new Array(Object.keys(symbolData).length).fill({
        x: 0,
        y: 0,
      });
      for (let prop in symbolData) {
        if (symbolData.hasOwnProperty(prop) && symbolData[prop].imageSize) {
          let data = symbolData[prop];
          this._symbolSizes[Number(data.ID)] = data.imageSize;
        }
      }

      if (this._symbolGfxObjects.length > 0) {
        this.scaleToImageSize();
      }
    } // clear on symboldata length -1 and length -2

    clearOverlayData() {
      if (this._reelSpinnerData && this._reelSpinnerData._symbolData) {
        for (let index = 0; index < this._reelSpinnerData._symbolData.length; index++) {
          this._reelSpinnerData._symbolData[index].overlayData = {};
        }
      }
    }

    scaleToImageSize() {
      let symbolData = this._reelSpinnerData.getSymbolData();

      for (let i = 0; i < this._symbolGfxObjects.length; ++i) {
        let symId = symbolData[i].symId;
        let width = this._symbolGfxObjects[i].symbol.texture.width;
        let height = this._symbolGfxObjects[i].symbol.texture.height;
        let x = this._symbolSizes[symId].x / width;
        let y = this._symbolSizes[symId].y / height;
        if (x && y) {
          // only scale if we have valid scales
          this._symbolGfxObjects[i].scale.set(x, y);
        } else {
          this._symbolGfxObjects[i].symbol.scale.set(0.5);
        }
      }
    }

    // Coin overlays
    createMultiplierOverlays() {
      let totalAppertureSize = this.getReelSpinnerData().getTotalAppertureSize();

      for (let i = 0; i < totalAppertureSize; ++i) {
        let gfxObject = this._symbolGfxObjects[i];
        //const overlayTextContainer = new PIXI.Container();
        //overlayTextContainer.name = gfxObject.name + ":overlayTextContainer";
        gfxObject.overlayTextContainer = resourceManager.createObject("container", "overlayTextContainer", gfxObject);
        //gfxObject.addChild(overlayTextContainer);

        let overlayText = resourceManager.createObject(
          "text",
          `reel${this._reelId}:row${i}`,
          gfxObject.overlayTextContainer,
          {
            text: "???",
            fontDefinition: "cashFishFontSpinningCoins",
            maxWidth: 150,
            anchor: { x: 0.5, y: 0.5 },
            x: 0,
            y: 0,
          }
        );

        overlayText.setText = function (text) {
          var oldVisible = this.visible;
          this.visible = true;
          if (text !== this.text) {
            this.text = text;
          }
          this.checkBounds(this.Props[layoutController.getCurrentLayout()].scale);
          this.visible = oldVisible;
        };

        overlayText.visible = false;
        this._overlays.push({
          overlayText,
        });
      }
    }

    getRandomCoinValue() {
      const weights = [474, 270, 100, 50, 25, 8];
      const cumulativeWeights = [];
      for (let i = 0; i < weights.length; i += 1) {
        cumulativeWeights[i] = weights[i] + (cumulativeWeights[i - 1] || 0);
      }
      const maxCumulativeWeight = cumulativeWeights[cumulativeWeights.length - 1];
      const randomNum = maxCumulativeWeight * Math.random();
      for (let i = 0; i < weights.length; i++) {
        if (cumulativeWeights[i] >= randomNum) {
          return gdk.formatCurrency(this._possibleCoinValues[i]);
        }
      }
    }

    createSlidingCollectOverlay() {
      if (this._reelId === 0 || this._reelId === 4) {
        let slidingCollectOverlay = resourceManager.createObject(
          "spine",
          `slidingCollectOverlay:reel${this._reelId}:symbol${this.slidingPoolLength}`,
          this,
          {
            name: "Fisherman",
            defaultAnimation: "Fisherman_Regular",
            x: 0,
            y: 0,
            anchor: 0.5,
          }
        );
        slidingCollectOverlay.reel = this._reelId;

        slidingCollectOverlay.visible = true;
        slidingCollectOverlay.alpha = 0;
        this.slidingPoolLength++;

        this.slidingCollectPool.push({
          number: this.slidingCollectPool.length,
          spine: slidingCollectOverlay,
          reel: this._reelId,
        });
      }
    }

    getSlidingCollectFromPool = function () {
      let overlay = undefined;

      if (this.slidingCollectPool.length > 0) {
        overlay = this.slidingCollectPool.pop();
      } else {
        this.createSlidingCollectOverlay();
        overlay = this.slidingCollectPool.pop();
      }
      return overlay;
    };

    fadeInSlidingCollect(object) {
      gsap.fromTo(
        object,
        {
          visible: true,
          alpha: 0,
        },
        {
          duration: 0.2,
          alpha: 1,
        }
      );
    }

    updateSymbolOverlays(ids, overlays) {
      /**
       * For coin collect, the amount is in pennies, so amount = 200 then show x2 on the front end
       *
       * coin symbol ID = 18, 38, 58, 78, 98
       */
      super.updateSymbolOverlays(ids, overlays);

      // Cash Overlays
      // Coin display mode is only turned on once reels have landed and we're moving into the coins feature.
      // This is to ensure when symbols come in as part of golden spins or clover spins their values are correctly assigned.
      if (!this.coinDisplayMode) {
        for (let symID = 0; symID < ids.length; symID++) {
          this._overlays[symID].overlayText.visible = false;
          // Fake coin symbols, which are just spinning through
          if (this._reelSpinnerData._symbolData[symID].overlayData.fakeMultiplierValue !== undefined) {
            const coin = resourceManager.get(`slotContainer:reelContainer:reel${this._reelId}:symbol${symID}:symbol`);
            const stakeController = resourceManager.getController("stakeController");
            const baseStake = stakeController.getBaseStake();
            //const randomCoinValue = this.getRandomCoinValue();
            const coinValue = gdk.formatCurrency(
              this._reelSpinnerData._symbolData[symID].overlayData.fakeMultiplierValue * baseStake
            );

            this._overlays[symID].overlayText.setText(gdk.formatCurrency(coinValue));
            this._reelSpinnerData._symbolData[symID].overlayData = {
              coinValue: coinValue,
            };

            this._overlays[symID].overlayText.visible = true;
            this._overlays[symID].overlayText.position.setX(coin.width / 2);
            this._overlays[symID].overlayText.position.setY(this._textPositionsPerSize[this.appertureHeight]);
            this._overlays[symID].overlayText.setMaxHeight(this._maxHeightPerSymbolSize[this.appertureHeight]);
          }

          // Coin symbols that will land!
          if (this._coinSymbolIds.includes(ids[symID])) {
            if (gameController.coins) {
              if (this._coinDataOnReel.length === 0) {
                if (this._reelSpinnerData._symbolData[symID].overlayData.coinValue === undefined) {
                  for (let index = 0; index < gameController.coins.length; index++) {
                    const coin = gameController.coins[index];

                    if (coin.coord.reel === this._reelId) {
                      if (coin.type === "Cash") {
                        this._coinDataOnReel.push(coin);
                      }
                    }
                  }
                  if (this._coinDataOnReel.length > 0) {
                    this._coinDataOnReel.sort((a, b) => b.coord.row - a.coord.row);
                  }
                }
              }
            }
          }
        }
      } else {
        //We're in coin display mode. We need to ensure all the coins overlays are correctly synced to their  actual positions.
        if (gameController.coins && gameController.coins.length !== 0) {
          for (let symID = 0; symID < ids.length; symID++) {
            this._overlays[symID].overlayText.visible = false;

            for (let i = 0; i < gameController.coins.length; i++) {
              if (this._coinSymbolIds.includes(ids[symID])) {
                if (
                  this._reelId === gameController.coins[i].coord.reel &&
                  symID === gameController.coins[i].coord.row
                ) {
                  if (gameController.coins[i].type === "Cash") {
                    const coin = resourceManager.get(
                      `slotContainer:reelContainer:reel${this._reelId}:symbol${symID}:symbol`
                    );

                    const cashValue = gdk.formatCurrency(gameController.coins[i].amount);

                    this._overlays[symID].overlayText.setText(cashValue);
                    this._overlays[symID].overlayText.visible = true;
                    this._overlays[symID].overlayText.position.setX(coin.width / 2);
                    this._overlays[symID].overlayText.position.setY(this._textPositionsPerSize[this.appertureHeight]);

                    this._overlays[symID].overlayText.setMaxHeight(this._maxHeightPerSymbolSize[this.appertureHeight]);

                    this._reelSpinnerData._symbolData[symID].overlayData = {
                      coinValue: cashValue,
                    };
                  }
                }
              }
            }
          }
        }
      }
      let reversedArray = [...ids].reverse();
      for (let index = 4; index < reversedArray.length && this._coinDataOnReel.length > 0; index++) {
        if (this._coinSymbolIds.includes(reversedArray[index])) {
          let currCoin = this._coinDataOnReel.shift();
          let coinValue = gdk.formatCurrency(currCoin.amount);
          let arrayIndex = reversedArray.indexOf(ids[index]);

          this._reelSpinnerData._symbolData[arrayIndex].overlayData = {
            coinValue: coinValue,
          };
        }
      }
      for (let i = 0; i < ids.length; i++) {
        if (this._reelSpinnerData._symbolData[i].overlayData.coinValue === undefined) {
          this._overlays[i].overlayText.visible = false;
        } else {
          if (
            this._coinSymbolIds.includes(ids[i]) ||
            ids[i] === 13 ||
            ids[i] === 33 ||
            ids[i] === 53 ||
            ids[i] === 73 ||
            ids[i] === 93
          ) {
            this._overlays[i].overlayText.visible = true;
            this._overlays[i].overlayText.setText(this._reelSpinnerData._symbolData[i].overlayData.coinValue);
            const coin = resourceManager.get(`slotContainer:reelContainer:reel${this._reelId}:symbol${i}:symbol`);
            this._overlays[i].overlayText.position.setX(coin.width / 2);
            this._overlays[i].overlayText.position.setY(this._textPositionsPerSize[this.appertureHeight]);
            this._overlays[i].overlayText.setMaxHeight(this._maxHeightPerSymbolSize[this.appertureHeight]);
          } else {
            this._reelSpinnerData._symbolData[i].overlayData.coinValue = undefined;
            this._overlays[i].overlayText.visible = false;
          }
        }
      }
    }
  }

  function create(json) {
    let numPreapp = json.numPreappertureSymbols || 2;
    let numPostapp = json.numPostappertureSymbols || 2;
    return new ReelSpinnerVisual(
      json.ID,
      json.ID + " container",
      json.appertureHeight,
      json.slotMachineName,
      json.minSymbolSpacing,
      1,
      numPreapp,
      numPostapp,
      json.startingAppertureHeight,
      json.megawaysSymbolSpacing
    );
  }

  function initialise(json, reelSpinnerVisual) {
    reelSpinnerVisual.initialise(json);
    reelSpinnerVisual.createMultiplierOverlays();
  }

  function getRequiredFiles() {
    return [];
  }

  resourceManager.registerObjectType("ReelSpinnerVisual", create, initialise, getRequiredFiles);
})();
